import _classCallCheck from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { deepMix } from '@antv/util';
var CanvasPanel = /*#__PURE__*/function () {
  function CanvasPanel(cfgs) {
    _classCallCheck(this, CanvasPanel);
    this._cfgs = deepMix(this.getDefaultCfg(), cfgs);
  }
  _createClass(CanvasPanel, [{
    key: "getDefaultCfg",
    value: function getDefaultCfg() {
      return {
        container: null
      };
    }
  }, {
    key: "get",
    value: function get(key) {
      return this._cfgs[key];
    }
  }, {
    key: "set",
    value: function set(key, val) {
      this._cfgs[key] = val;
    }
  }, {
    key: "initPlugin",
    value: function initPlugin(graph) {
      var parentNode = this.get('container');
      parentNode.addEventListener('dragover', function (e) {
        graph.emit('canvas:mousemove', e);
      });
      parentNode.addEventListener('dragleave', function (e) {
        graph.emit('canvas:mouseleave', e);
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.get('canvas').destroy();
      var container = this.get('container');
      container.parentNode.removeChild(container);
    }
  }]);
  return CanvasPanel;
}();
export default CanvasPanel;